<!--
  -  Copyright (c) Qwoach LLC 2022. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 28/12/2022
  -->

<template>
	<span v-bind="attrsStylesClass">
		<qw-input
			v-bind="attrsCustom"
			v-model="valueData"
			@change="notifyValueChanged"
			style="width: 130px;">
			<template #append>
				<el-color-picker
					class="ml-2 mt-1"
					size="small"
					v-model="valueData"
					@change="notifyValueChanged"
					v-bind="attrsCustom"/>
			</template>
		</qw-input>

<!--			<qw-input-->
<!--				v-bind="$attrs"-->
<!--				style="width: 130px;">-->
<!--				-->
<!--			<template #append>-->
<!--				<el-color-picker-->
<!--					class="ml-2 mt-1"-->
<!--					size="small"-->
<!--					v-bind="$attrs"/>-->
<!--			</template>-->
<!--		</qw-input>-->
	</span>
</template>

<script>

import BaseVModelView from "@/core/components/BaseVModelView.vue";
import BaseComponent from "@/core/components/BaseComponent.vue";

export default {
	name: "QwColorPicker",
	extends: BaseVModelView,
	inheritAttrs: false,

	props: {
		modelValue: String,
	},

	data() {
		return {
			color: null,
		}
	},

	computed: {
		attrsCustom() {
			let {'onUpdate:modelValue': vmodel, onChange, ...rest} = this.$attrs
			return {
				...rest,
			}
		}
	},

}
</script>

<style lang="scss">

</style>
